<template>
  <div class="comment-item">
    <div class="comment-content">
      <span class="name">
        {{ comment.createUid.name }}
      </span>
      <span v-if="comment.replyToId">
        &nbsp;{{ $t('okr.comment.reply') }}
        <span class="name">
          {{ comment.replyToId.createUid.name }}
        </span>
      </span>
      <span class="name">:&nbsp;</span>
      <span v-html="comment.body" />
    </div>
    <FileList
      :files="comment.attachmentIds"
      :can-edit="false"
    />
    <div class="comment-meta">
      <span>
        {{ formatDate(comment.date) }}
      </span>
      <span class="comment-action">
        <a-button
          type="text"
          size="small"
          class="comment-button"
          @click="onReply"
        >
          {{ $t('okr.comment.reply') }}
        </a-button>
        <template v-if="user.uid === comment.createUid.id">
          <a-divider
            type="vertical"
            :style="{ margin: 0 }"
          />
          <a-button
            type="text"
            size="small"
            class="comment-button"
            @click="deleteComment"
          >
            {{ $t('shared.delete') }}
          </a-button>
        </template>
      </span>
    </div>
    <CommentInputGroup
      v-if="isReplying"
      :entity="entity"
      :replying-comment="replyingComment"
      :placeholder="$t('okr.comment.replyPlaceholder')"
      :style="{ marginTop: '4px' }"
      @sent="onSent"
    />
  </div>
</template>

<script>
import * as moment from 'moment'
import { ref, computed, toRaw } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'

import { deleteComment as deleteCommentApi } from '@/api/comment'
import CommentInputGroup from './CommentInputGroup'
import FileList from '@/components/FileList'

export default {
  name: 'CommentItem',
  components: {
    CommentInputGroup,
    FileList
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    comment: {
      type: Object,
      required: true
    }
  },
  emits: [
    'delete',
    'sent'
  ],
  setup (props, { emit }) {
    const { t } = useI18n()
    const isReplying = ref(false)
    const { state } = useStore()
    const user = computed(() => state.user)
    const comment = toRaw(props.comment)
    const replyingComment = {
      replyToId: comment.id,
      parentId: comment.parentId && comment.parentId.id
    }

    function formatDate (dateStr) {
      return moment(dateStr).format('YYYY-MM-DD HH:mm:ss')
    }

    function deleteComment () {
      deleteCommentApi(props.comment.id)
        .then(() => {
          message.success(t('okr.comment.deletedMessage'))
          emit('delete')
        })
    }

    function onReply () {
      isReplying.value = !isReplying.value
    }

    function onSent () {
      isReplying.value = false
      emit('sent')
    }

    return {
      isReplying,
      user,
      formatDate,
      replyingComment,
      onReply,
      deleteComment,
      onSent
    }
  }
}
</script>

<style lang="less" scoped>
.comment-item {
  margin-top: 8px;
}

.comment-content {
  // display: flex;
  font-size: 14px;

  .name {
    font-weight: bold;
  }
}

.comment-meta {
  font-size: 12px;
}

.comment-action {
  margin-left: 8px;
}

.comment-button {
  font-size: 12px;
}

:deep(.sendComment) {
  display: contents;
}
</style>
